"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchTenantContextInput = exports.tenantContextSchema = exports.tenantChoiceSchema = void 0;
// One active tenant context per session, changed only by an explicit switch (`RPM-067`, `O2`, `J-269`).
const zod_1 = require("zod");
/** One tenant the account holds an assignment in, as the top bar names it. */
exports.tenantChoiceSchema = zod_1.z
    .object({ tenantId: zod_1.z.uuid(), legalName: zod_1.z.string() })
    .meta({ id: "TenantChoice", description: "A tenant the account may act in" });
/**
 * The session's context: the tenant it acts in, and every tenant it could switch to.
 *
 * `active` IS NULL when the account's assignments name more than one tenant and none is chosen yet —
 * "one active tenant context is chosen at sign-in" — or when they name none. A platform assignment
 * names no tenant and is never listed here (`RPM-067` row 4).
 */
exports.tenantContextSchema = zod_1.z
    .object({ active: exports.tenantChoiceSchema.nullable(), tenants: zod_1.z.array(exports.tenantChoiceSchema) })
    .meta({ id: "TenantContext", description: "The session's active tenant and its choices" });
exports.switchTenantContextInput = zod_1.z
    .strictObject({ tenantId: zod_1.z.uuid() })
    .meta({ description: "The tenant to make this session's context" });
//# sourceMappingURL=tenant-context.js.map